import React, { forwardRef } from 'react';

export function Option(props: React.OptionHTMLAttributes<HTMLOptionElement>) {
  return <option {...props}></option>;
};

export const Select = forwardRef<HTMLSelectElement, React.SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, ...props }, ref) => {
    return <select ref={ref} className={`${className} rounded p-3 text-[0.875rem]`} {...props}></select>;
  }
);
